import React from "react";
import { PieChart, Pie, Cell, Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import ForecastBarChart from "./ForecastBarChart";
import './SalesDashboard.css';

const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff7f50", "#d684d8"]; // Example colors

const SalesDashboard = ({
  quarterGoals = { current: 0, goal: 1000000 },
  dealsData = [],
  funnelData = [],
  forecastData = [],
}) => {
  return (
    <div className="sales-dashboard">
      {/* Row 1: Q1 Goals and Deals Breakdown */}
      <div className="dashboard-row">
        {/* Quarter Goals */}
        <div className="dashboard-widget quarter-goals">
          <h4>Q1 Goals</h4>
          <p>${quarterGoals.current.toLocaleString()}</p>
          <p>Goal: ${quarterGoals.goal.toLocaleString()}</p>
          <div className="progress-bar">
            <div
              className="progress"
              style={{
                width: `${Math.min(
                  (quarterGoals.current / quarterGoals.goal) * 100,
                  100
                )}%`,
              }}
            ></div>
          </div>
        </div>

        {/* Deals Breakdown */}
        <div className="dashboard-widget deals-breakdown">
          <h4>Deals Breakdown</h4>
          <PieChart width={400} height={300}>
            <Pie
              data={dealsData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              fill="#8884d8"
              label
            >
              {dealsData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Legend />
          </PieChart>
        </div>
      </div>

      {/* Row 2: Sales Funnel and Forecast */}
      <div className="dashboard-row">
        {/* Sales Funnel */}
        <div className="dashboard-widget sales-funnel">
          <h4>Sales Funnel</h4>
          <BarChart width={400} height={300} data={funnelData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#82ca9d">
              {funnelData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Bar>
          </BarChart>
        </div>

        {/* Forecast */}
        <div className="dashboard-widget forecast">
  <h4>Forecast</h4>
  <ForecastBarChart
    data={forecastData.map(({ month, revenue }) => ({
      name: month,
      value: revenue,
    }))}
  />
</div>

      </div>
    </div>
  );
};

export default SalesDashboard;


